import arrow from "@/assets/icons/right.svg";
interface ButtonProps {
  text: string;
  onClick: () => void;
  size?: "sm" | "md" | "lg";
  type?: "primary" | "secondary" | "tertiary" | "quaternary";
  iconPosition?: "none" | "right" | "left";
  disabled?: boolean;
}

const Button = ({
  text,
  size = "md",
  type = "primary",
  iconPosition,
  onClick,
  disabled = false,
}: ButtonProps) => {
  let buttonClasses = "";

  if (size === "sm") {
    buttonClasses += "lc-px-6 lc-text-lg lc-h-[40px] lc-text-base lc-w-fit";
  } else if (size === "md") {
    buttonClasses +=
      "lc-px-6 md:lc-px-10 lc-h-[40px] lc-w-[130px] md:lc-h-[48px] md:lc-w-[176px] lc-text-sm md:lc-text-base";
  } else if (size === "lg") {
    buttonClasses +=
      "lc-px-6 md:lc-px-10 lc-h-[40px] lc-w-[130px] md:lc-h-[53px] md:lc-w-[215px] lc-text-sm md:lc-text-xl";
  }

  if (type === "primary") {
    buttonClasses +=
      " lc-gap-3 lc-bg-cfa-blue-500 hover:lc-brightness-90 disabled:lc-brightness-100 lc-rounded-[100px] lc-text-white";
  } else if (type === "secondary") {
    buttonClasses +=
      " !lc-px-0 hover:lc-underline hover:lc-underline-offset-4 !lc-w-fit lc-gap-4 lc-text-white";
  } else if (type === "tertiary") {
    buttonClasses +=
      " hover:lc-bg-white hover:lc-text-black lc-border lc-border-white lc-border-solid lc-rounded-[100px] lc-text-white";
  } else if (type === "quaternary") {
    buttonClasses +=
      " !lc-px-0 lc-underline lc-underline-offset-4 !lc-w-fit lc-gap-4 lc-text-white";
  }

  return (
    <button
      onClick={onClick}
      className={`lc-flex lc-items-center hover:lc-transition-all hover:lc-ease-in hover:lc-duration-200 lc-justify-center ${buttonClasses} lc-font-azo-sans lc-font-medium lc-leading-none disabled:lc-opacity-50 disabled:lc-cursor-not-allowed`}
      disabled={disabled}
    >
      {iconPosition === "left" && (
        <img
          src={arrow}
          width={18}
          height={18}
          className="lc-w-[18px] lc-h-[18px] lc-rotate-180"
          alt=""
        ></img>
      )}
      <span>{text}</span>
      {iconPosition === "right" && (
        <img
          src={arrow}
          width={16}
          height={16}
          className="lc-w-4 lc-h-4"
          alt=""
        ></img>
      )}
    </button>
  );
};

export default Button;
